




import { Component, Vue } from 'vue-property-decorator';
import { ApiService } from '@/services/ApiService';

@Component
export default class MessageAfterRefresh extends Vue {

  public mounted() {
    const showMessage = localStorage.getItem('showMessage');
    const infoMessage = localStorage.getItem('infoMessage');
    if (showMessage === 'true') {
      ApiService.defaultInfoHandler(infoMessage);
      localStorage.setItem('showMessage', 'false');
      localStorage.setItem('infoMessage', '');
    }
  }
}
